import React from "react";
import Main from "./components/Main";
import "@aws-amplify/ui-react/styles.css"; // Amplify UI styles
import CookieBanner from "./components/CookieBanner";

// import { withAuthenticator } from "@aws-amplify/ui-react";

const App = () => {
  return (
    <div className="App">
      {/* <Navbar /> */}
      <Main />
      <CookieBanner />
    </div>
  );
};

export default App;
